import { apiClient } from './client';


export const getHomePageContents = () => {
    return apiClient.get(`/luxury/page`)
};

export const getSinglePage = (slug: string) => {
    const path = slug ? `/luxury/page/${slug}` : `/luxury/page`;
    return apiClient.get(path);
};
